import { render, staticRenderFns } from "./EditorLayout.vue?vue&type=template&id=9142ef86&scoped=true&"
import script from "./EditorLayout.vue?vue&type=script&lang=js&"
export * from "./EditorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9142ef86",
  null
  
)

export default component.exports